export const styles = {
  "svg rect:not(.unknown)": {
    "stroke-width": "1px",
    "stroke": "#ffffff",
    transition: "all .4s"
  },
  "svg rect:not(.unknown):hover": {"stroke-width": ".8px !important"},
  ".unknown": {"fill": "transparent !important"},
  ".nodata": {
    "fill": "transparent !important",
    "stroke": "transparent !important"
  },
  ".FULFILLED": {"background-color": "#ff4757 !important", "fill": "#ff4757"},
  ".FORMATION_ALTERNANCE_INSERVICE": {
    "background-color": "#00ffc9 !important",
    "fill": "#00ffc9"
  },
  ".FORMATION_INSERVICE": {
    "background-color": "#7bed9f !important",
    "fill": "#7bed9f"
  },
  ".PAIDHOLIDAY_OFFSERVICE": {
    "background-color": "rgb(217,217,217) !important",
    "fill": "rgb(217,217,217)"
  },
  ".SENIORITYHOLIDAY_OFFSERVICE": {
    "background-color": "rgb(217,217,217) !important",
    "fill": "rgb(217,217,217)"
  },
  ".UNPAIDHOLIDAY_OFFSERVICE": {
    "background-color": "rgb(217,217,217) !important",
    "fill": "rgb(217,217,217)"
  },
  ".PAUSE_INSERVICE": {
    "background-color": "#4fc3f7 !important",
    "fill": "#4fc3f7"
  },
  ".FULFILLED_PAUSE": {
    "background-color": "#4fc3f7 !important",
    "fill": "#4fc3f7"
  },
  ".ACTION_INSERVICE": {
    "background-color": "#7bed9f !important",
    "fill": "#7bed9f"
  },
  ".REPAS_OFFSERVICE": {
    "background-color": "rgb(191,191,191) !important",
    "fill": "rgb(191,191,191)"
  },
  ".BRIEF_INSERVICE": {
    "background-color": "#7bed9f !important",
    "fill": "#7bed9f"
  },
  ".FULFILLED_SYSTEM_PROCESSED_FORMATIONCONTINUE": {
    "background-color": "#00ffc9 !important",
    "fill": "#00ffc9"
  },
  ".INCOHERENCE_VALIDATED_FORMATIONCONTINUE": {
    "background-color": "#8a2fd3 !important",
    "fill": "#8a2fd3"
  },
  ".FULFILLED_VALIDATED_FORMATIONCONTINUE": {
    "background-color": "#7bed9f !important",
    "fill": "#7bed9f"
  },
  ".FORMATION_MUTUALISATION_INSERVICE": {
    "background-color": "#7bed9f !important",
    "fill": "#7bed9f"
  },
  ".FORMATION_CONTINUE_INSERVICE": {
    "background-color": "#7bed9f !important",
    "fill": "#7bed9f"
  },
  ".FULFILLED_SYSTEM_PROCESSED_CONTROLEQUALITE": {
    "background-color": "#00ffc9 !important",
    "fill": "#00ffc9"
  },
  ".INCOHERENCE_VALIDATED_CONTROLEQUALITE": {
    "background-color": "#8a2fd3 !important",
    "fill": "#8a2fd3"
  },
  ".FULFILLED_VALIDATED_CONTROLEQUALITE": {
    "background-color": "#7bed9f !important",
    "fill": "#f4c8c8"
  },
  ".CONTROLEQUALITE_MUTUALISATION_INSERVICE": {
    "background-color": "#7bed9f !important",
    "fill": "#7bed9f"
  },
  ".CONTROLE_QUALITE_INSERVICE": {
    "background-color": "#7bed9f !important",
    "fill": "#7bed9f"
  },
  ".INACTIF_OFFSERVICE": {
    "background-color": "#dfe4ea !important",
    "fill": "#dfe4ea"
  },
  ".IRP_INSERVICE": {"background-color": "#7bed9f !important", "fill": "#7bed9f"},
  ".HORS_PRODUCTION_OFFSERVICE": {
    "background-color": "#dfe4ea !important",
    "fill": "#dfe4ea"
  },
  ".PREAVIS_OFFSERVICE": {
    "background-color": "rgb(217,217,217) !important",
    "fill": "rgb(217,217,217)"
  },
  ".ALLAITEMENT_OFFSERVICE": {
    "background-color": "rgb(217,217,217) !important",
    "fill": "rgb(217,217,217)"
  },
  ".EXCEPTIONALHOLIDAY_OFFSERVICE": {
    "background-color": "rgb(217,217,217) !important",
    "fill": "rgb(217,217,217)"
  },
  ".ALIVE_INSERVICE": {
    "background-color": "#2ed573 !important",
    "fill": "#2ed573"
  },
  ".INCOHERENCE_OFF": {
    "background-color": "#8a2fd3 !important",
    "fill": "#8a2fd3"
  },
  ".INCOHERENCE_ON": {"background-color": "#d500a0 !important", "fill": "#d500a0"},
  ".INCOHERENCE_OFF_BYUSER": {
    "background-color": "#8a2f59 !important",
    "fill": "#8a2f59"
  },
  ".INCOHERENCE_ON_BYUSER": {
    "background-color": "#d50a59 !important",
    "fill": "#d50a59"
  },
  ".CONGE_INCOHERENCE": {
    "background-color": "rgb(217,217,217) !important",
    "fill": "rgb(217,217,217)"
  },
  ".break_off": {"background-color": "#F9A825 !important", "fill": "#F9A825"}
}



// WEBPACK FOOTER //
// ./src/app/modules/chartBlocks/style.ts